import React, { useState } from 'react';
import { func, instanceOf, string } from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXT_FIELD,
  DROPDOWN,
  PASSWORD,
  USERNAME,
  ACT_ACCOUNTID_CHECK,
} from '../../shared/DEConstants';
import { CopyDataToClipBoardModal } from '../../../../util/CommonUtils';
import LightTooltip from '../../shared/LightTooltip';
import ShowEye from '../../../../containers/ShowEye';
import HideEye from '../../../../containers/HideEye';
import CopyIcon from '../../shared/icons/CopyIcon';

const DestinationModalContent = ({
  partner,
  setPartnerDetails,
  buttonType,
  impersonated,
  currentAccountId,
  getDesinationPassword,
}) => {
  const { logo, name, id } = partner;
  const [isPassword, setIsPassword] = useState(true);

  const _CopyDataToClipBoardModal = destinationId => {
    getDesinationPassword(destinationId);
  };

  const _setAsterisk = password => {
    const passwordArr = password.split('');
    let asterisk = '';
    passwordArr.forEach(() => (asterisk += '*'));
    return asterisk;
  };

  const _handleAddOrUpdate = evt => {
    evt.preventDefault();
    const formData = document.getElementById('partnerForm').elements;
    const partnerCopy = cloneDeep(partner);
    const updatedAttributes = partnerCopy.attributes.map(attr => {
      const formValue = formData[Number(attr.attrId) - 1].value;
      const updatedAttr = {
        ...attr,
        atans: formValue,
      };
      return updatedAttr;
    });
    partnerCopy.attributes = updatedAttributes;
    setPartnerDetails(partnerCopy);
  };

  const _renderDeopdown = (options, id, selected) => {
    if (options) {
      const optionArray = options.split(', ');
      const selectOption = optionArray.map(option => {
        return (
          <option key={option} value={option}>
            {option}
          </option>
        );
      });
      return (
        <select
          name={id}
          id={id}
          defaultValue={selected || optionArray[0]}
          disabled={impersonated}
        >
          {selectOption}
        </select>
      );
    }
    return null;
  };

  const renderPartnerField = field => {
    switch (field.atty) {
      case TEXT_FIELD:
        return (
          <div className="distro__partner--modal--form--element">
            <input
              name={field.attrId}
              type="text"
              id={field.attrId}
              defaultValue={
                !ACT_ACCOUNTID_CHECK.includes(currentAccountId) &&
                name === 'AudienceXpress (fka FreeWheel)'
                  ? field.atans
                  : field.atans || field.atva
              }
              disabled={impersonated}
            />
          </div>
        );
      case DROPDOWN:
        return (
          <div className="distro__partner--modal--form--element">
            {_renderDeopdown(field.atva, field.attrId, field.atans)}
          </div>
        );
      case USERNAME:
        return (
          <div className="distro__partner--modal--form--password">
            <input
              name={field.attrId}
              type="text"
              id={field.attrId}
              defaultValue={field.atans || ''}
              disabled={impersonated}
            />
            {impersonated && (
              <span
                className="distro__partner--modal--form--password--copyicon"
                onClick={() => CopyDataToClipBoardModal(field.atans)}
              >
                <CopyIcon />
              </span>
            )}
          </div>
        );
      case PASSWORD:
        return (
          <div className="distro__partner--modal--form--password">
            <input
              name={field.attrId}
              type={isPassword ? 'password' : 'text'}
              id={field.attrId}
              defaultValue={
                impersonated
                  ? _setAsterisk(field.atans || '')
                  : field.atans || ''
              }
              disabled={impersonated}
            />
            {impersonated ? (
              <span
                className="distro__partner--modal--form--password--copyicon"
                onClick={() => _CopyDataToClipBoardModal(partner.id)}
              >
                <CopyIcon />
              </span>
            ) : (
              <span
                className="distro__partner--modal--form--password--icon"
                onClick={() => setIsPassword(!isPassword)}
              >
                {isPassword ? <ShowEye /> : <HideEye />}
              </span>
            )}
          </div>
        );
      default:
    }
    return null;
  };

  const renderDestinationFields = data => {
    return data.attributes.map(field => {
      if (field.atty) {
        return (
          <div
            key={field.attrId}
            className="distro__partner--modal--form--field"
          >
            <label
              htmlFor={field.attrId}
              className="distro__partner--modal--form--label"
            >
              <span>{field.attr}</span>

              {field.athe && <LightTooltip title={field.athe} />}
            </label>
            {renderPartnerField(field)}
          </div>
        );
      }
      return null;
    });
  };

  return (
    <div className="distro__partner--modal">
      <div className="distro__partner--modal--header">
        <div className="distro__partner--image">
          <img src={logo} alt={name} />
        </div>
        <div className="distro__partner--title">{name}</div>
      </div>
      <div className="distro__partner--modal--body">
        <form
          id="partnerForm"
          onSubmit={_handleAddOrUpdate}
          className="distro__partner--modal--form"
        >
          <div className="distro__partner--modal--form--body">
            {partner && renderDestinationFields(partner)}
          </div>
          <div className="de__partner--actions">
            <button
              type="submit"
              className="de--btn de--btn__primary"
              disabled={impersonated}
            >
              {buttonType}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

DestinationModalContent.propTypes = {
  partner: instanceOf(Object),
  setPartnerDetails: func,
  buttonType: string,
  impersonated: Boolean,
  currentAccountId: Number,
  getDesinationPassword: func,
};

export default DestinationModalContent;
